import React from 'react'
import { Box, Loading as LoadingSpinner } from '@maui/elements'

export const Loading = () => <Box textAlign="center" mt="25%"><LoadingSpinner /></Box>
